module.exports = __webpack_public_path__ + "img/flag_uk.6d12b048.svg";